import React from 'react';

import UserAPI from 'service/api/UserAPI';

import SetoCanvasPage from 'pages/SetoCanvasPage';

import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm} from 'views/FormElements';

const Form = ({isSubmitting}) => {
	let submitBtn = "Change Password";
	if(isSubmitting === true)
		submitBtn = <span>Change Password <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;

	return <RGForm>
			<h4 style={{fontStyle: "italic", margin: "10px 0", textAlign: "center"}}>Enter your new password:</h4>
            <Input name="password" type="password" label="Password: " style={{marginBottom: "0px", marginTop: "10px"}}/>
            <Input name="confirmPassword" type="password" label="Confirm Password: " style={{marginBottom: "0px", marginTop: "10px"}}/>
			
			
			<div className="flexRow" style={{justifyContent: "space-between", alignItems: "flex-end"}}>
				<SubmitButton style={{marginTop: "10px"}} color="primary" disabled={isSubmitting}>
					{submitBtn}
				</SubmitButton>
			</div>
	</RGForm>
};

class ChangePasswordPage extends React.Component {
    constructor(props) {
		super(props);
		this.INIT_VALUES = {password: '', confirmPassword: ''};
        this.handleFormSubmission = this.handleFormSubmission.bind(this);
        
        this.state = {passwordChanged: false};
    }
    
	validationScheme() {
		return Yup.object().shape({
			password: Yup.string().required('Enter your password.').min(6, "Password cannot be less than 6 chars."),
		    confirmPassword: Yup.string().test('passwords-match', 'Passwords must match', function(value){
                return this.parent.password === value
              })
		});
	}

	handleFormSubmission(value, {setSubmitting, setFieldValue}) {
        const match = this.props.match;
        const token = match.params.token;
        
        UserAPI.changePassword(token, value.password, function(success) {
            setSubmitting(false);

            if(success) {
                this.setState({passwordChanged: true});
            }
        }.bind(this));
	}

	render() {
		return (
            <SetoCanvasPage id="changePasswordPage" title="Change Password | Seto Canvas">

                <div style={{width: '50%', margin: '30px auto', padding: '30px', border: '1px solid #dcd6d6', borderRadius: '10px'}}>
                    {
                        this.state.passwordChanged === true &&
                        <div>
                            <h3 style={{textAlign: 'center'}}><i className="fa fa-check-circle-o" style={{color: "#1e8910"}} aria-hidden="true"></i> Your password has been changed successfully.</h3>
                        </div>
                    }

                    {
                        this.state.passwordChanged === false &&
                        
                        <Formik enableReinitialize initialValues={this.INIT_VALUES} onSubmit={this.handleFormSubmission}
                            validationSchema={this.validationScheme} render={formikProps => {
                                return <Form {...formikProps} forgetPasswordLink={this.props.forgetPasswordLink} />
                            }} />
                        
                    }
                
                </div>

            </SetoCanvasPage>
			);
		
	}
}


export default ChangePasswordPage;


// WEBPACK FOOTER //
// ./src/pages/ChangePasswordPage.js